import { ResumeDto } from "@reactive-resume/dto";

import { axios } from "@/client/libs/axios";

import defaultData from "./default_data.json";

export const findResumeById = async (data: { id: string }) => {
  const result: ResumeDto = defaultData as ResumeDto;
  return result;
  const response = await axios.get<ResumeDto>(`/resume/${data.id}`);

  return response.data;
};

export const findResumeByUsernameSlug = async (data: { username: string; slug: string }) => {
  const response = await axios.get<ResumeDto>(`/resume/public/${data.username}/${data.slug}`);

  return response.data;
};
